import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp } from '../utils/motion';
export function FinalCTA() {
  return <section className="py-24 lg:py-32 px-4 sm:px-6 lg:px-8 bg-navy-deep text-center" data-id="element-253" data-mp="3udp26xtznyt6">
      <motion.div {...fadeUp} className="max-w-4xl mx-auto" data-id="element-254" data-mp="c7twtozhd0w5">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-6 leading-tight" data-id="element-255" data-mp="856zx9nycps3">
          Build more capable people. <br className="hidden md:block" data-id="element-256" data-mp="m3wxsrilithi" />
          Stronger institutions. Better leadership.
        </h2>

        <p className="text-lg text-surface-muted/80 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-257" data-mp="h52frrsgd8yg">
          SyNeural’s CJI and NCJI frameworks connect assessment with
          development. Noetivra would make their tasks, findings, and pathways
          accessible through an interactive workspace.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-258" data-mp="14vzgs9ipmlux">
          <a href="/contact" className="bg-white text-navy font-bold px-8 py-4 rounded-md hover:bg-surface-muted transition-colors duration-150 whitespace-nowrap" data-id="element-259" data-mp="zx4s4qy2a32w">
            Request a Demo
          </a>
          <a href="/partnerships" className="bg-transparent border border-white/30 text-white font-medium px-8 py-4 rounded-md hover:bg-white/10 transition-colors duration-150 whitespace-nowrap" data-id="element-260" data-mp="2h5u3ktd2usf7">
            Start a Partnership Conversation
          </a>
        </div>
      </motion.div>
    </section>;
}